export default __webpack_public_path__ + "static/media/default.0a1086554d8142107e5878ecaa2d45c8.png";